import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";
import PageTitle from "../../components/common/pageTitle";
import Spinner from "../../shared/Spinner";
import { withRouter } from "react-router-dom";
import companyName from "../../../store/mobxStore/companyName";
import { useParams, useHistory } from "react-router-dom";
import PaymentView from "../../../service/payment_view/PaymentView";

function Renewpaymentpaypal(props) {
  const params = useParams();
  let service = new PaymentView();

  const [state, setState] = useState({
    code: "",
    message: "",
    transaction_password: "",
    userName: "",
  });

  useEffect(() => {
    checkForRenewal();
  }, []);

  const checkForRenewal = async () => {
    await service.RenewpaymentStatusCheck(params).then((res) => {
      if (res.status === 200) {
        // props.history.push({
        //     pathname: '/dashboard/'
        // })

        setTimeout(function () {
          //venel reload adhyam cheyth nokk
          props.history.push({ pathname: "/upgrade_validity" });
          window.location.reload();
        }, 2000);
      } else {
        if (res.error.code === 1002) {
          props.history.push("/logout");
        } else if (res.error.code === 1057) {
          props.history.push({
            pathname: "/dashboard",
            state: {
              error: true,
              message: "permissionDenied",
            },
          });
        } else if (res.error.code === 1084) {
          props.history.push({
            // pathname: `/payment_view_fail/${params.token}/${params.PayerID}`,
            pathname: `/payment_view_fail_renew/`,
          });
        }
      }
    });
  };

  return (
    <div
      className="h-500"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        left: "0",
        top: "-80px",
        height: "calc(100vh)",
        position: "fixed",
        width: "calc(100%)",
      }}
    >
      <center>
        <h3>Please wait while we process your payment</h3>
      </center>
      <br />
      <br />
      <br />
      <br />
      <Spinner />
    </div>
  );
}
export default withTranslation()(withRouter(Renewpaymentpaypal));
